import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { Provider } from 'react-redux'
import store from './redux/store'
import reportWebVitals from './reportWebVitals'
import TagManager from 'react-gtm-module'
import Smartlook from 'smartlook-client'

// Get the query parameter from the URL
const queryParams = new URLSearchParams(window.location.search);
const idletime = queryParams.get('idletime');
if (process.env.NODE_ENV !== "development") {
TagManager.initialize({ gtmId: 'GTM-5SDFWLD' });
Smartlook.init(process.env.REACT_APP_SMARTLOOK_KEY,
  {
    advancedNetwork: {
      allowedUrls: [
        /^https:\/\/sjc1\.qualtrics\.com\/API\/v3\/surveys\/SV_9twfUsQHQRDLnNQ\/sessions.*$/,
        /^https:\/\/cdn\.contentful\.com\/spaces\/jtpzln57ts22.*$/,
      ]
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
)


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
